import { NoticiaSchema } from "../domain/entities/Noticia";
import { fileManagementService } from "../services/fileManagementService";
import { newsService } from "../api/newsService";
import { fileFromValue } from "../utils/fileUtils";

export const createNews = async (formData) => {
  const parsed = NoticiaSchema.parse({
    ...formData,
    fijado:
      formData.fijado === true ||
      formData.fijado === "true" ||
      formData.fijado === "1",
  });

  let imgUrl = parsed.img;
  let previewUrl = parsed.preview;
  // id_img es el identificador del archivo en el storage; la API de subida
  // lo devuelve como fileName.
  let idImg = null;

  // El UploadField entrega un File único (maxFiles=1); fileFromValue
  // también acepta FileList/array por compatibilidad con <input type="file">.
  const imgFile = fileFromValue(formData.img);
  const previewFile = fileFromValue(formData.image_preview);

  // Se sube el archivo y, cuando hay documento (pdf/ppt) u otra imagen,
  // también la vista previa; la API devuelve las URLs para el payload.
  if (imgFile || previewFile) {
    const result = await fileManagementService.uploadNewsFiles({
      img: imgFile,
      preview: previewFile,
    });
    imgUrl = result.imgUrl || imgUrl;
    previewUrl = result.previewUrl || previewUrl;
    idImg = result.imgName || null;
  }

  const payload = {
    titulo: parsed.titulo,
    bajada: parsed.bajada,
    fijado: Boolean(parsed.fijado),
    fecha_publicacion: parsed.fecha_publicacion,
    descripcion: parsed.descripcion,
    etiqueta: parsed.etiqueta,
    tipo: parsed.tipo,
    url: parsed.url,
    img: imgUrl,
    id_img: idImg,
    preview: previewUrl,
  };

  const response = await newsService.createNews(payload);
  return response;
};

export default createNews;